<template>
  <div class="foot">
    <van-tabbar v-model="active" safe-area-inset-bottom route active-color="#ee0a24" inactive-color="#000">
      <!-- 电影 (首页) -->
      <van-tabbar-item to="/MoviesHome">
        <div class="t-a-c">
          <van-icon name="video-o" size="1.5rem" />
        </div>
        <div class="t-a-c mt">
          首页
        </div>
      </van-tabbar-item>

      <!-- 影片 (全部列表) -->
      <van-tabbar-item :to="moviesListPath">
        <div class="t-a-c">
          <van-icon name="apps-o" size="1.5rem" />
        </div>
        <div class="t-a-c mt">
          影片
        </div>
      </van-tabbar-item>
      
      <!-- 影院 (列表) -->
      <van-tabbar-item :to="cinemaPath">
        <div class="t-a-c">
          <van-icon name="shop-o" size="1.5rem" />
        </div>
        <div class="t-a-c mt">
          影院
        </div>
      </van-tabbar-item>
       
      <!-- 我的 (电影版个人中心) -->
      <van-tabbar-item to="/MovieMy">
        <div class="t-a-c">
          <van-icon name="user-o" size="1.5rem" />
        </div>
        <div class="t-a-c mt">
          我的
        </div>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "MovieNav",
  data() {
    return {
      active: 0,
    };
  },
  computed: {
    moviesListPath() {
      return '/MoviesList';
    },
    cinemaPath() {
      return '/CinemasList';
    }
  }
};
</script>

<style lang='scss' scoped>
.foot {
  .iconfont {
    font-size: 1.3rem;
  }
}

.mt {
  margin-top: 0.2rem;
  font-size: 0.8rem;
}

.van-tabbar {
  height: 4rem;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
  z-index: 9999 !important;
}
</style>